import { Component, Mixins, Watch } from "vue-property-decorator";
import page from "./page";

@Component
class ScrollAppBarPage extends Mixins(page) {
  scrolled = false;

  background = "linear-gradient(180deg, #0596FF 0%, rgba(5, 150, 255, 0) 100%)";

  get appbar(): any {
    let color = this.themeColor;
    let background = "";

    if (!this.scrolled) {
      color = "transparent";
      background = this.background;
    }

    return {
      color,
      back: true,
      dark: true,
      style: [{ background }]
    };
  }

  @Watch("scrolled")
  handleScrolledChange() {
    this.setProperties();
  }

  mounted() {
    window.addEventListener("scroll", this.handleScroll().bind(this));
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll().bind(this));
  }

  handleScroll() {
    return this.$common.utils.helper.throttle(e => {
      this.scrolled = e.target.scrollingElement?.scrollTop > 20;
    }, 10);
  }
}

export default ScrollAppBarPage;
